



































































































































































































































































































































import { ColunaRelatorio, FiltroViewForm, ViewRelatorio } from '@/models/views/ViewRelatorio'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindRelatorioUseCase, SaveRelatorioUseCase } from '@/usecases'
import axios, { CancelTokenSource } from 'axios'
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import ListaDeLojas from '@/components/usuario/ListaDeLojas.vue'
import { Loja, Usuario } from '@/models'
import ListagemDeRelatorioPorUsuario from '@/components/relatorio/ListagemDeRelatorioPorUsuario.vue'
import DetalhesDeRelatorioDeGrid from '@/components/relatorio/DetalhesDeRelatorioDeGrid.vue'
import ConstrutorDeRelatorio from '@/components/relatorio/ConstrutorDeRelatorio.vue'
import { AgGridState } from '@/models/views/AgGrid'
import { v4 as uuidv4 } from 'uuid'
import { DeleteRelatorioUseCase } from '@/usecases/relatorio/DeleteRelatorioUseCase'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import { gerarRelatorioGrid, montarPivot, gerarRelatorioBlocosDeGrade } from '@/shareds/dashboard/gerar-relatorio-grid'
import { primaryColor } from '@/plugins/vuetify'
import { converterVisaoLegada, ehTemplateDoConstrutor } from '@/shareds/relatorio/visao-legada'

@Component({
	components: {
		ListaDeLojas,
		ListagemDeRelatorioPorUsuario,
		DetalhesDeRelatorioDeGrid,
		ConstrutorDeRelatorio,
		SeletorDeUsuario,
		DatePicker,
	},
})
export default class TelaDeRelatorios extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDeListagemDeRelatorioPorUsuario!: ListagemDeRelatorioPorUsuario
	findUseCase = new FindRelatorioUseCase()
	saveUseCase = new SaveRelatorioUseCase()
	deleteUseCase = new DeleteRelatorioUseCase()

	views: ViewRelatorio[] = []
	obrigatorio = obrigatorio
	relatorioSelecionado: ViewRelatorio | null = null
	dadosDaTabela: object[] = []
	listFiltros: FiltroViewForm[] = []
	valid: boolean | true = true
	loading: boolean | false = false
	exibirGrid: boolean | false = false
	lojas: Loja[] = []

	relatorioDetalhado: ViewRelatorio | null = null
	mostraDialogoDeListagemDeRelatorios = false
	mostraDialogoDeDetalheDeRelatorio = false
	mostraDialogoDeCompartilharVisao = false
	confirmandoCompartilhamentoDaVisao = false
	carregandoPresets = false
	aba = null
	carregandoOpcoesDosFiltros = false
	opcoesPorFiltro: any[] = []

	estadosSalvosGrid: AgGridState[] = []
	templateObrigatorio: AgGridState | null = null
	usuarioParaCompartilhar: Usuario | null = null
	presetClicado: AgGridState | null = null

	painelAberto = 0

	cancelToken: CancelTokenSource | null = null

	get deveObrigatoriamenteInformarVisao() {
		return UserLoginStore.permiteRegraDeNegocio('obrigatorio-selecionar-visao-de-relatorio')
	}

	get viewsVendas() {
		return this.views.filter(view => view.categoria === 'Vendas')
	}

	get viewsEstoque() {
		return this.views.filter(view => view.categoria === 'Estoque')
	}

	get viewsFiscal() {
		return this.views.filter(view => view.categoria === 'Fiscal')
	}

	get viewsFinanceiro() {
		return this.views.filter(view => view.categoria === 'Financeiro')
	}

	selecionarViewDaAba(chave: string) {
		switch(chave) {
			case 'aba-1':
				return this.viewsVendas
			case 'aba-2':
				return this.viewsEstoque
			case 'aba-3':
				return this.viewsFiscal
			case 'aba-4':
				return this.viewsFinanceiro
			default:
				return []
		}
	}

	get colunas() {
		if (this.dadosDaTabela.length > 0) {
			return Object.keys(this.dadosDaTabela[0])
		}
		return []
	}

	get colunasConfiguradas(): ColunaRelatorio[] | [] {
		return this.relatorioSelecionado ? this.relatorioSelecionado.colunas : []
	}

	get colunasBuilder(): any[] {
		const primeiro = this.dadosDaTabela[0] || {}
		return this.colunas
			.map(coluna => {
				const conf = (this.colunasConfiguradas as ColunaRelatorio[]).find(c => c.colunaDaView == coluna)
				if (!conf) {
					return { header: coluna, field: coluna, numerico: typeof primeiro[coluna] === 'number', moeda: false, aggFunc: null, sequencia: Number.MAX_VALUE }
				}
				return {
					header: conf.nomeColuna,
					field: coluna,
					numerico: conf.tipoColuna === 'number',
					moeda: conf.tipoColuna === 'number' && conf.formatoExibicao === 'money',
					aggFunc: conf.tipoColuna === 'number' ? conf.totalizador || null : null,
					sequencia: conf.sequencia || Number.MAX_VALUE,
				}
			})
			.sort((a, b) => a.sequencia - b.sequencia)
			.map(({ sequencia, ...coluna }) => coluna)
	}

	opcoesPorFiltroFormatado(filtroId) {
		const opcoesDoFiltro = this.opcoesPorFiltro.filter(opcao => opcao.filtroId === filtroId).map(opcao => opcao.opcoes)
		return opcoesDoFiltro && opcoesDoFiltro.length > 0 ? opcoesDoFiltro[0] : null
	}

	created() {
		this.carregar()
	}

	@Watch("listFiltros")
	onChangeListFiltros() {
		if (!this.listFiltros) return

		this.opcoesPorFiltro = []

		this.listFiltros.forEach(async filtro => {
			if (filtro.possuiOpcoes) {
				const opcoes = await this.carregarOpcoesFiltro(filtro)

				this.opcoesPorFiltro.push({
					filtroId: filtro.id,
					opcoes: opcoes,
				})
			}
		})
	}

	async carregar() {
		this.cancelToken = axios.CancelToken.source()
		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}

		if (UserLoginStore.perfil) {
			this.views = await this.findUseCase.listarViewsPorPerfil(UserLoginStore.perfil.id, axiosConfig)
		}
	}

	selecionarRelatorio(valor: ViewRelatorio) {
		this.painelAberto = 1
		this.relatorioSelecionado = valor
		this.templateObrigatorio = null

		if (!this.relatorioSelecionado) return

		this.listFiltros = this.relatorioSelecionado.filtros.map(filtro => {
			return {
				id: filtro.id,
				nomeFiltro: filtro.nomeFiltro,
				valor: '',
				tipo: filtro.tipo,
				possuiOpcoes: filtro.possuiOpcoes,
			} as FiltroViewForm
		})

		if (this.deveObrigatoriamenteInformarVisao) {
			this.buscarPresets()
		}
	}

	async carregarOpcoesFiltro(filtroView: FiltroViewForm) {
		try {
			this.carregandoOpcoesDosFiltros = true
			const opcoes = await this.findUseCase.listarOpcoesDeFiltro(filtroView.id)

			return opcoes
		} catch (error: any) {
			AlertModule.setError(error)
			return null
		} finally {
			this.carregandoOpcoesDosFiltros = false
		}
	}

	@Watch('relatorioSelecionado')
	onChange() {
		this.exibirGrid = false
	}

	async buscarPresets() {
		try{
			this.carregandoPresets = true
			if(!this.relatorioSelecionado) throw new Error('Selecione um relatório para buscar os templates')

			this.estadosSalvosGrid = await this.findUseCase.buscarPresetsDoUsuario(this.relatorioSelecionado.id)
		} catch(error){
			AlertModule.setError(error)
		} finally {
			this.carregandoPresets = false
		}
	}

	async aplicarParams() {
		if (!this.form.validate()) return
		if (!this.relatorioSelecionado) return
		if (this.relatorioSelecionado.filtrarLoja && this.lojas.length === 0) {
			AlertModule.setInfo('Informe pelo menos uma loja para efetuar a consulta.')
			return
		}
		if (this.deveObrigatoriamenteInformarVisao && !this.templateObrigatorio) {
			AlertModule.setError('Selecione uma visão ou template para visualizar o relatório.')
			return
		}

		this.cancelToken = axios.CancelToken.source()

		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}

		const parametrosObject = Object.assign({}, ...this.listFiltros.map(filtro => ({ [filtro.nomeFiltro]: filtro.valor })))
		const paramsTratados = this.relatorioSelecionado.filtrarLoja
			? { ...parametrosObject, lojasId: String(this.lojas.map(loja => loja.id)) }
			: parametrosObject

		try {
			this.loading = true

			// Templates chegam antes dos dados: o construtor aplica o template padrão assim que recebe as colunas.
			const [dados, presets] = await Promise.all([
				this.findUseCase.efetuarConsultaRelatorio(this.relatorioSelecionado.id, paramsTratados, axiosConfig),
				this.findUseCase.buscarPresetsDoUsuario(this.relatorioSelecionado.id),
			])
			this.estadosSalvosGrid = presets
			this.dadosDaTabela = dados

			this.exibirGrid = true
			this.painelAberto = 3
		} catch(error) {
			this.exibirGrid = false
			AlertModule.setError(error)
		} finally {
			this.loading = false
		}
	}

	mostrarDialogoDeListagemDeRelatorios(relatorio) {
		this.relatorioDetalhado = relatorio
		this.mostraDialogoDeListagemDeRelatorios = true
	}

	fecharListagemDeRelatorio() {
		this.relatorioDetalhado = null
		this.mostraDialogoDeListagemDeRelatorios = false
	}

	mostrarDialogoDeDetalheDeRelatorio(relatorio) {
		this.relatorioDetalhado = relatorio
		this.mostraDialogoDeDetalheDeRelatorio = true
	}

	fecharDetalheDeRelatorio() {
		this.relatorioDetalhado = null
		this.mostraDialogoDeDetalheDeRelatorio = false
	}

	get nomeEmpresa(): string {
		const sub = window.location.hostname.split('.')[0] || ''
		return sub ? sub.charAt(0).toUpperCase() + sub.slice(1) : ''
	}

	async marcarPadrao(payload: { presetId: string; favorito: boolean }) {
		try {
			await this.saveUseCase.favoritarPreset(payload.presetId, payload.favorito)
			await this.buscarPresets()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	get podeGlobal(): boolean {
		return !!UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get usuarioLogadoId(): string {
		return UserLoginStore.usuario?.id || ''
	}

	get corPrimariaTema(): string {
		return primaryColor()
	}

	get filtrosAtuais(): any[] {
		const fs = (this.listFiltros || []).map((f: any) => ({ label: f.nomeFiltro, valor: String(f.valor ?? '') }))
		if (this.relatorioSelecionado && this.relatorioSelecionado.filtrarLoja && this.lojas.length) {
			fs.push({ label: 'Lojas', valor: this.lojas.map((l: any) => l.nomeFantasia || l.nome).join(', ') })
		}
		return fs.filter(f => f.valor)
	}

	get templatesRelatorio(): any[] {
		const presets = (this.estadosSalvosGrid || []).filter(p => p.presetSalvo)
		return [
			...presets.filter(ehTemplateDoConstrutor),
			...presets.filter(p => !ehTemplateDoConstrutor(p)).map(converterVisaoLegada),
		]
	}

	async salvarTemplate(payload: any) {
		if (!this.relatorioSelecionado) return
		const template = {
			id: payload.id || uuidv4(),
			nome: payload.nome,
			presetSalvo: { tipo: 'relatorio-pdf', config: payload.config },
			viewRelatorioId: this.relatorioSelecionado.id,
			usuarioId: this.usuarioLogadoId,
			global: !!payload.global,
		} as AgGridState
		try {
			await this.saveUseCase.salvarPreset(template)
			AlertModule.setInfo(('Template salvo') as any)
			await this.buscarPresets()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async removerTemplate(id: string) {
		try {
			await this.deleteUseCase.removerPreset(id)
			await this.buscarPresets()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	aoGerarRelatorio(cfg: any) {
		const base: any[] = cfg.linhas || []
		const comum = {
			corPrimaria: primaryColor(),
			empresa: this.nomeEmpresa,
			geradoEm: new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
			titulo: this.relatorioSelecionado ? this.relatorioSelecionado.nomeRelatorio : 'Relatório',
			filtros: cfg.filtros || this.filtrosAtuais,
			orientacao: cfg.orientacao,
		}

		if (cfg.pivot && cfg.formato === 'blocos') {
			gerarRelatorioBlocosDeGrade({
				...comum,
				linhas: base,
				bloco: {
					idFields: cfg.pivot.linhas,
					colunaField: cfg.pivot.colunaField,
					metricas: cfg.pivot.valores,
					imagemField: cfg.imagemField,
				},
			})
			return
		}

		if (cfg.pivot) {
			const { colunas, linhas } = montarPivot(base, cfg.pivot)
			gerarRelatorioGrid({
				...comum,
				colunas,
				agrupadores: [],
				linhas,
				mostrarSubtotais: false,
				mostrarTotalGeral: cfg.totalGeral,
			})
			return
		}

		const camposQuebra: string[] = cfg.quebraFields || []
		const agrupadores = camposQuebra.map((field: string) => ({
			field,
			header: (this.colunasBuilder.find((c: any) => c.field === field) || {}).header || field,
		}))

		gerarRelatorioGrid({
			...comum,
			colunas: cfg.colunas,
			agrupadores,
			linhas: base,
			mostrarSubtotais: cfg.subtotais,
			mostrarTotalGeral: cfg.totalGeral,
		})
	}

	filtrarPresetSalvo (item: any, queryText: any, itemText: any) {
        if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
	}

	mostrarDialogoDeCompartilhamentoDePreset(preset: AgGridState) {
		if (!preset) return
		this.usuarioParaCompartilhar = null
		this.mostraDialogoDeCompartilharVisao = true
		this.presetClicado = preset
	}

	async confirmarCompartilhamentoDaVisao() {
		if (!this.presetClicado?.id) return
		if (!this.usuarioParaCompartilhar) return

		try {
			this.confirmandoCompartilhamentoDaVisao = true
			await this.saveUseCase.compartilharPreset(this.presetClicado.id, this.usuarioParaCompartilhar.id, this.presetClicado.nome)
			AlertModule.setSuccess('Compartilhado com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.mostraDialogoDeCompartilharVisao = false
			this.confirmandoCompartilhamentoDaVisao = false
			this.presetClicado = null
		}
	}
}
